import { identifyApiErrorType, identifyErrorCategory, ERROR_CATEGORIES, ERROR_TYPES } from './errorTypes'
import { registerError } from './registeredErrors'
import { markErrorAsReported } from './errorFlag'

export function prepareErrorForSentry(error, context, options = {}) {
  const errorCategory = identifyErrorCategory(error)

  registerError(error, errorCategory, context)

  // If it will redirect to error view, mark it as reported (to avoid duplications)
  if (options.willRedirect) {
    markErrorAsReported()
  }

  // Create base tags with the context info
  const baseTags = {
    error_category: errorCategory,
    component: context.component || 'unknown',
    route: context.route || 'unknown',
    method: context.method || 'unknown'
  }

  // Add specific tags by category
  if (errorCategory === ERROR_CATEGORIES.API) {
    return {
      ...baseTags,
      error_type: identifyApiErrorType(error)
    }
  } else {
    return {
      ...baseTags,
      error_type: ERROR_TYPES.UNKNOWN
    }
  }
}
